export type LLMProvider = 'openai' | 'claude' | 'gemini' | 'custom';

export type LLMProviderExtended = LLMProvider | 'openai-realtime' | 'gemini-voice' | 'elevenlabs';

export interface ProviderMetadata {
  id: LLMProvider;
  label: string;
  icon: string;
  color: string;
  description: string;
}

export const PROVIDER_METADATA: Record<LLMProvider, ProviderMetadata> = {
  openai: {
    id: 'openai',
    label: 'OpenAI',
    icon: '🤖',
    color: 'bg-sky-100 text-sky-700 border-sky-200',
    description: 'Modelli GPT (GPT-5.4, GPT-4o, o3, o4-mini)',
  },
  claude: {
    id: 'claude',
    label: 'Claude (Anthropic)',
    icon: '🧠',
    color: 'bg-purple-100 text-purple-700 border-purple-200',
    description: 'Modelli Anthropic Claude (Sonnet/Opus/Haiku)',
  },
  gemini: {
    id: 'gemini',
    label: 'Gemini (Google)',
    icon: '✨',
    color: 'bg-blue-100 text-blue-700 border-blue-200',
    description: 'Modelli Google Gemini (2.x/3.x)',
  },
  custom: {
    id: 'custom',
    label: 'Custom (OpenAI-compatible)',
    icon: '🧩',
    color: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    description: 'Endpoint registrati (Ollama, vLLM, RunPod, LM Studio, Together, Groq…)',
  },
};

export const HARDCODED_ONLY_PROVIDERS: ReadonlyArray<LLMProviderExtended> = [
  'openai-realtime',
  'gemini-voice',
];

export interface ModelCapabilities {
  tools?: boolean;
  strict_schema?: boolean;
  embedding?: boolean;
  rerank?: boolean;
  vision?: boolean;
  realtime?: boolean;
}

export const PROVIDER_LIST_FOR_LLM_PICKER: ReadonlyArray<{
  id: LLMProvider;
  name: string;
  icon: string;
  color: string;
}> = (Object.values(PROVIDER_METADATA)).map((p) => ({
  id: p.id,
  name: p.label,
  icon: p.icon,
  color: p.color,
}));
